<template>
  <div id="app">
    <navigation />
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view class="font-none" />
    </keep-alive>
    <router-view v-else class="font-none" />
    <bottom />
  </div>
</template>

<script>
import navigation from '@/components/navigation'
import bottom from '@/components/navigation-bottom'
export default {
  components: { navigation, bottom },
  data() {
    return {
      url: ''
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
